// extracted by mini-css-extract-plugin
export default {"siteIntro":"siteIntro__ihTZr","fadeOutSiteIntro":"fadeOutSiteIntro__QLOfD"};